import { AppBar,  Box, Container, Toolbar, Typography, Link, Stack} from "@mui/material";
import React , {useContext} from 'react';
import c4ulogo from '../../assets/logo.png';
import Profile from "./Profile";
import { UserContext } from '../../contexts/UserContext';
import AcsStatus from "./AcsStatus";
import CmsStatus from "./CmsStatus";
import LanguageSelector from "./LanguageSelector";

export default function Header() {
  
  return (
    <Container disableGutters maxWidth="100%">
    <Box sx={{ flexGrow: 1, padding: 0}}>
      <AppBar position="static">
        <Toolbar sx={{background:'linear-gradient(158deg, #09686C -73.61%, #2E405C 55.26%);' }}>
          <Link href="/">
            <img src={c4ulogo} alt="Connect4U Logo" style={{ height: "40px", width: "40px" }} />
          </Link>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            &nbsp;
          </Typography>
          <Stack direction="row" alignItems="center">
            <LanguageSelector />
            <CmsStatus />
            <AcsStatus />
            <Profile />
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  </Container>
  );
}